import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import translate from '@/api/translate';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'AddBtn',
  props: {
		text: {
			type: String,
			default: translate.ShowText('添加')
		}
	},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const props = __props

	const emits = __emit;

	const Submit = () => {
		emits("change");
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "add-btn-1",
      type: "primary",
      onClick: Submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.text), 1)
      ]),
      _: 1
    })
  ]))
}
}

})